import { useEffect, useState } from "react";

const navLinks = [
  { label: "精选推荐", href: "#featured" },
  { label: "高分排行", href: "#ranking" },
  { label: "漫画分类", href: "#categories" },
  { label: "新作速递", href: "#new" },
  { label: "专题解读", href: "#articles" },
  { label: "常见问题", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const input = form.elements.namedItem("q") as HTMLInputElement;
    const val = input?.value?.trim();
    if (!val) return;
    window.REACT_APP_NAVIGATE(`/?q=${encodeURIComponent(val)}`);
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent border-b border-white/10"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-4 md:px-6">
        <a
          href="#home"
          className="flex items-center gap-2.5 whitespace-nowrap"
          aria-label="香香漫画 首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-white">
            <i className="ri-book-open-fill text-lg" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading text-xl md:text-2xl tracking-wide ${
              scrolled ? "text-primary-600" : "text-white"
            }`}
          >
            香香漫画
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap text-sm transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <form
            onSubmit={onSearch}
            className={`hidden items-center gap-2 rounded-full px-3.5 py-2 md:flex ${
              scrolled
                ? "bg-background-100 border border-background-200"
                : "bg-white/15 border border-white/20"
            }`}
            role="search"
          >
            <i
              className={`ri-search-line text-sm ${scrolled ? "text-foreground-500" : "text-white/80"}`}
              aria-hidden="true"
            ></i>
            <input
              type="search"
              name="q"
              placeholder="搜索漫画名称"
              aria-label="搜索漫画"
              className="w-36 bg-transparent text-sm outline-none placeholder:text-foreground-400"
            />
          </form>

          <a
            href="#featured"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm text-white transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            立即开看
          </a>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-full lg:hidden ${
              scrolled ? "text-foreground-900" : "text-white"
            }`}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}